/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */
const batchedMethods = [
    'setLineWidth', 'setDrawColor', 'line', 'setFillColor', 'rect',
    'setFontSize', 'setFont', 'setTextColor', 'text', 'circle', 'pushEsignField', 'addImage'
];

const sendBatchAsync = (worker) => {
    return new Promise((resolve, reject) => {
        const hashID = generateGuid();
        const batch = worker._batch;
        worker._batch = [];
        
        worker._messageHandlers.set(hashID, { resolve, reject });
        
        worker.postMessage({
            method: 'executeBatch',
            params: [batch],
            hashID
        });
    });
};

const initWorkerHandlers = (worker) => {
    worker._messageHandlers = new Map();
    worker.onmessage = ($event) => {
        if (_.get($event, 'data.method')) {
            const { method, result, hashID, error, errorMessage } = $event.data;
            const handler = worker._messageHandlers.get(hashID);
            if (handler) {
                if (error) {
                    handler.reject(new Error(errorMessage || `Worker error in method "${method}"`));
                } else {
                    handler.resolve(result);
                }
                worker._messageHandlers.delete(hashID);
            }
        }
    };
    worker.onerror = (errorEvent) => {
        console.error('[PDF Worker] Uncaught worker error:', errorEvent);
        worker._messageHandlers.forEach(({ reject }) => {
            reject(new Error(`Worker uncaught error: ${errorEvent.message}`));
        });
        worker._messageHandlers.clear();
    };
};

export default async (worker, event, ...params) => {
    if (!worker._batch) {
        worker._batch = [];
    }
    if (!worker._messageHandlers) {
        initWorkerHandlers(worker);
    }
    if (_.isUndefined(worker.loadedFonts)) {
        worker.loadedFonts = [];
    }

    if (event === 'setFont' || event === 'loadCustomFontAsync') {
        if (event === 'loadCustomFontAsync' && !worker.loadedFonts.includes(params[0])) {
            worker.loadedFonts.push(params[0]);
        }
        if (event === 'setFont' && !worker.loadedFonts.includes(params[0])) {
            console.error(
                `TRYING TO SET CUSTOM FONT-FAMILY, THAT WASN'T LOADED: '${params[0]}'.`,
                'CALL \'loadCustomFontAsync\' FUNCTION BEFORE!'
            );
        }
    }

    if (batchedMethods.includes(event)) {
        worker._batch.push({ method: event, params });
        return true;
    }

    if (worker._batch.length > 0) {
        await sendBatchAsync(worker);
    }

    const hashID = generateGuid();
    return new Promise((resolve, reject) => {
        worker._messageHandlers.set(hashID, { resolve, reject });
        worker.postMessage({
            method: event,
            params,
            hashID
        });
    });
};

export function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        (c) => {
            let r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
}
